import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { Fragment, memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { RecapVM } from 'civil-status/view-models/step-form';
import { ClassNameMap, createStyles, makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import { noop } from 'shell/utils/noop';
import { DateTime } from 'luxon';

const useStyles = makeStyles(() => {
  return createStyles({
    link: {
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
  });
});

interface RecapFormProps {
  recap?: Array<RecapVM>;
  onClickRecap: (step: string, index: number) => void;
  dateFormationAct?: string;
}

const RecapFormComponent = ({
  recap,
  onClickRecap,
  dateFormationAct = '',
}: RecapFormProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const classes: ClassNameMap<string> = useStyles();

  const dataFormazioneAtto = dateFormationAct ? DateTime.fromISO(dateFormationAct) : undefined;
  const date = dataFormazioneAtto?.toFormat('dd/MM/yyyy') || undefined;
  const time = dataFormazioneAtto?.toFormat('HH:mm') || undefined;

  const idAnsc: string = useMemo(() => {
    return recap?.find((item) => Boolean(item.idAnsc))?.idAnsc || '';
  }, [recap]);

  return (
    <Grid item xs={12}>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-RecapForm-content"
          id="panel-RecapForm-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>
            <Fragment>
              Scenario&nbsp;
              {date && time ? `stesura dell'atto formato il ${date} alle ore ${time}` : ''}
              {idAnsc ? (
                <Fragment>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Atto&nbsp;<b>{idAnsc}</b>
                </Fragment>
              ) : undefined}
            </Fragment>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid item xs={12} container spacing={2}>
            {recap?.map((item: RecapVM, index) => (
              <Grid item lg={4} md={6} xs={12} key={(item.step || '') + (item.request || '')}>
                <span
                  className={item.disabled ? '' : classes.link}
                  onClick={item.disabled ? noop : () => onClickRecap(item.step || '', index)}
                >
                  {item.request ? (
                    <>
                      <span>
                        {`${item.request}${
                          item.request && item.request[item.request?.length - 1] === '?' ? '' : ':'
                        }`}
                      </span>
                      &nbsp;
                    </>
                  ) : undefined}
                  <span style={{ fontWeight: 'bold' }}>{item.response}</span>
                </span>
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

RecapFormComponent.displayName = 'Accordion Recap Form component';

const RecapForm = memo(RecapFormComponent);

export default RecapForm;
